import { useParams, Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SERVICES_LIST, IMG } from "@/lib/brand";
import { Section, PageHeader, Eyebrow } from "@/components/common";

const DETAILS = {
  "production-musicale": {
    title: "CRÉER. PRODUIRE. DONNER UNE IDENTITÉ À VOTRE MUSIQUE.",
    text: "AL Music Records accompagne les artistes et les créateurs dans la conception et la réalisation de leurs projets musicaux. De l'idée initiale à la finalisation du morceau, nous intervenons sur les différentes étapes de la production afin de construire un projet cohérent avec l'identité de l'artiste.",
    sections: [
      ["Composition & production", "Écriture musicale, production instrumentale et arrangement pour donner vie à vos morceaux."],
      ["Direction artistique", "Définition d'une identité sonore et orientation artistique du projet."],
      ["Production phonographique", "Singles, EP, albums et coproductions structurés de bout en bout."],
      ["Préparation des sorties", "Structuration et accompagnement pour préparer vos publications."],
    ],
    ctas: [["SOUMETTRE MON PROJET", "/contact?tab=projet"], ["DEMANDER UN DEVIS", "/contact?tab=studio"]],
    image: IMG.hands,
  },
};

const GENERIC_SECTIONS = {
  "direction-artistique": ["Identité sonore", "Orientation artistique", "Arrangements", "Suivi"],
  "production-phonographique": ["Singles", "EP", "Albums", "Coproduction"],
  studio: ["Enregistrement", "Voix", "Voix off", "Captation sonore"],
  "mixage-mastering": ["Édition", "Traitement vocal", "Mixage", "Mastering"],
  "production-sonore": ["Montage", "Post-production", "Sound design", "Habillage sonore", "Bruitage"],
  audiovisuel: ["Voix off", "Post-production sonore", "Mixage", "Mastering", "Exports"],
  "accompagnement-artistique": ["Développement", "Structuration", "Préparation des sorties"],
  booking: ["Développement", "Prospection", "Coordination"],
  "projets-culturels": ["Ateliers", "Transmission", "Actions culturelles"],
};

export default function ServiceDetail() {
  const { slug } = useParams();
  const meta = SERVICES_LIST.find((s) => s.key === slug);
  const detail = DETAILS[slug];

  if (detail) {
    return (
      <div data-testid="service-detail-page">
        <PageHeader eyebrow="Production musicale" title={detail.title} subtitle={detail.text} image={detail.image} />
        <Section className="py-20">
          <div className="grid sm:grid-cols-2 gap-6">
            {detail.sections.map(([t, d]) => (
              <div key={t} className="card-dark p-7">
                <h3 className="font-display font-bold text-xl text-gold">{t}</h3>
                <p className="text-slate-300 mt-3 leading-relaxed">{d}</p>
              </div>
            ))}
          </div>
          <div className="mt-12 flex flex-wrap gap-4">
            {detail.ctas.map(([label, to]) => (
              <Link key={label} to={to} className="btn-gold">{label}</Link>
            ))}
          </div>
        </Section>
      </div>
    );
  }

  const sections = GENERIC_SECTIONS[slug] || [];
  return (
    <div data-testid="service-detail-page">
      <PageHeader eyebrow="Service" title={meta ? meta.title : "Service"} subtitle={meta ? meta.desc : ""} image={IMG.console} />
      <Section className="py-20">
        {sections.length > 0 && (
          <>
            <Eyebrow>Nos prestations</Eyebrow>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-6">
              {sections.map((s) => (
                <div key={s} className="card-dark p-6">
                  <h3 className="font-display font-semibold text-lg">{s}</h3>
                </div>
              ))}
            </div>
          </>
        )}
        <div className="mt-12 flex flex-wrap gap-4">
          <Link to="/contact?tab=projet" className="btn-gold">SOUMETTRE MON PROJET</Link>
          <Link to="/booking-studio" className="btn-ghost">RÉSERVER LE STUDIO <ArrowRight size={16} /></Link>
        </div>
      </Section>
    </div>
  );
}
